import React from 'react';
import PropTypes from 'prop-types';
import ContentBox from '../../../layout/component/ContentBox';
import Row from '../../../bootstrap/component/Row';
import Column from '../../../bootstrap/component/Column';
import {REQUEST_MEDICAL_EVALUATION} from "../../ui-definition/process-ui";
import Select from "../../../form/component/Select";
import LabelInput from "../../../form/component/LabelInput";
import currentUserHasAccess from "../../../../util/widget-helper";
import ValidationMessageList from "../../../validation/component/ValidationMessageList";

const MEDICAL_EVAL_REASON = [
    { id: 'pa_needed', value: 'PA treatment needed?'},
    { id: 'caries', value: 'Caries?'},
    { id: 'xray_needed', value: 'Xray/OPG needed?'},
    { id: 'orthodontic', value: 'Evaluate orthodontic treatability'},
    { id: 'recessions', value: 'Recessions?'},
    { id: 'other', value: 'Other'},
];

const reasonName = 'ReasonMedicalEval';

const RequestMedicalEvalWidget = ({ reasonMedicalEvalObject, changeProcessContext, saveProcessContext, validationMessageList }) => {

    if (!currentUserHasAccess(REQUEST_MEDICAL_EVALUATION)) {
        return null;
    }

    return (
        <ContentBox title="Medical Evaluation Reason">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList} />
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Reason">
                        <Select
                            name={reasonName}
                            object={reasonMedicalEvalObject}
                            valueList={MEDICAL_EVAL_REASON}
                            addEmpty={true}
                            readOnly={false}
                            onChange={(name, value) => {
                                changeProcessContext(name, value)
                                saveProcessContext()
                            }}
                        />
                    </LabelInput>
                </Column>
                <Column size={6} />
            </Row>
        </ContentBox>
    )
}

RequestMedicalEvalWidget.propTypes = {
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    reasonMedicalEvalObject: PropTypes.object,
    validationMessageList: PropTypes.array.isRequired,
}

export default RequestMedicalEvalWidget


// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/RequestMedicalEvalWidget.js